export default __webpack_public_path__ + "static/media/receipt.f0facd0a.svg";